import _get from 'lodash/get';
import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { contain } from '../../../../utils/textures';
import Icon from '../../../../icon/icon.component';
import Incentive from '../../../../incentive/incentive.component';
import { getLinesCount } from '../../../../incentive/incentive.utils';
import { defaultContext, getSizes, getInitialStyle } from './heroMetadata.style';

export default class HeroMetadata extends Lightning.Component {
  static _template() {
    return _merge(
      {
        ProgramLogo: {
          Logo: {},
        },
        Incentive: {
          type: Incentive,
        },
        Title: {},
        IconsRow: {
          ServiceIcon: {
            type: Icon,
          },
          ExtraDetails: {},
          CsaIcon: {
            type: Icon,
          },
        },
      },
      getInitialStyle(this._style),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  set item(value) {
    const { title, extraDetails, csaPicto, incentives } = value;

    const logo = _get(value, 'logo.src', '');
    const sizes = getSizes(this._style.screenSize);
    const isExtraDetailsVisible = Boolean(extraDetails);
    const isCsaIconVisible = Boolean(csaPicto);
    const isIconsRowVisible = isExtraDetailsVisible || isCsaIconVisible;
    const incentiveLines = getLinesCount(incentives);

    this.patch({
      ProgramLogo: {
        visible: Boolean(logo),
        Logo: {
          texture: {
            ...contain(logo, sizes.programLogo.w, sizes.programLogo.h),
            hasAlpha: true,
          },
        },
      },
      Incentive: {
        visible: incentiveLines > 0,
        data: {
          linesCount: incentiveLines,
          w: sizes.iconsRow.w,
          incentives,
          colorMode: this._style.colorMode,
        },
      },
      Title: {
        visible: Boolean(title),
        text: {
          text: title,
        },
      },
      IconsRow: {
        visible: isIconsRowVisible,
        ExtraDetails: {
          visible: isExtraDetailsVisible,
          text: {
            text: extraDetails,
          },
        },
        CsaIcon: {
          visible: isCsaIconVisible,
          iconData: {
            picto: csaPicto,
            viewBox: sizes.icon,
          },
        },
      },
    });
  }
}
